import React, { Component } from 'react';
import {
  USER_ROLE_ADMIN,
} from 'common/userRoles';

import {
  DATA_TABLE_VIEW_ID_INVOICES_ALL,
  DATA_TABLE_VIEW_ID_INVOICES_BY_STATUS,
} from 'common/dataTableConstants';

import { SCREEN_ID_ADMIN_FINANCE_INVOICES } from 'client/constants/screenIds';
import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrPage from 'client/components/SrPage';
import SrH1 from 'client/components/SrH1';
import SrDataTableInvoices from 'client/components/financeAdmin/SrDataTableInvoices';

function getStatusFromUrlShortViewId(invoiceViewShortId) {
  if (invoiceViewShortId.indexOf('by-status') === 0) {
    const status = invoiceViewShortId.replace('by-status-', '');
    return status;
  }
  return null;
}

function getDataTableViewIdFromUrlShortViewId(invoiceViewShortId) {
  const filterByInvoiceStatus = getStatusFromUrlShortViewId(invoiceViewShortId);
  if (filterByInvoiceStatus) {
    return `${DATA_TABLE_VIEW_ID_INVOICES_BY_STATUS}_${filterByInvoiceStatus}`;
  }
  switch (invoiceViewShortId) {
    case 'all': {
      return DATA_TABLE_VIEW_ID_INVOICES_ALL;
    }
  }
}

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_FINANCE_INVOICES)
@withScrollToTop
class FinancesInvoicesPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Finances - Invoices | Sunroom Rentals',
  })

  render() {
    const { match: { params: { invoiceViewShortId } } } = this.props;
    const viewId = getDataTableViewIdFromUrlShortViewId(invoiceViewShortId);
    const invoiceStatus = getStatusFromUrlShortViewId(invoiceViewShortId);
    return (
      <SrPage
        navbarProps={{
          redirectLogoTo: '/admin',
          backButtonLink: '/admin',
        }}
      >
        <div className='width-90'>
          <SrH1>invoices</SrH1>
          <SrDataTableInvoices
            viewId={viewId}
            invoiceStatus={invoiceStatus}
          />
        </div>
      </SrPage>
    );
  }
}

FinancesInvoicesPage.displayName = 'FinancesInvoicesPage';

export default FinancesInvoicesPage;
